import { IConfig } from '@cian/config/shared';
import { setCookie } from '@cian/utils/lib/browser/cookie';

import { getCookie } from '../../../../browser/utils/cookie';
import { ROUTE_ONBOARDING_STORAGE_KEY, ROUTE_ONBOARDING_CONFIG_KEY } from '../../../constants/map';

export const getOnboardingViews = (): number => {
  const value = getCookie(ROUTE_ONBOARDING_STORAGE_KEY);
  const displayCount = value && /^\d+$/.test(value) ? parseFloat(value) : 0;

  return displayCount;
};

export const setOnboardingViews = (value: number): void => {
  setCookie(ROUTE_ONBOARDING_STORAGE_KEY, String(value), { expires: 365 * 86400, secure: false });
};

export const getIsOnboardingEnabled = (config: IConfig): boolean => {
  return config.get<boolean>(ROUTE_ONBOARDING_CONFIG_KEY) || false;
};
